var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 26,
    fill: "url(#paint0_radial_1402_1689)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 13C73.866 13 77 16.134 77 20V53.5778C77 68.4189 57.7517 74.2469 49.5193 61.8983L38.8321 45.8675C38.6126 45.5384 38.4431 45.4737 38.3595 45.4467C38.2203 45.4016 37.988 45.381 37.7102 45.4651C37.4325 45.5492 37.2505 45.6953 37.1597 45.8099C37.1052 45.8788 37 46.0266 37 46.4222V80C37 83.866 33.866 87 30 87C26.134 87 23 83.866 23 80V46.4222C23 31.5811 42.2484 25.7532 50.4808 38.1017L61.168 54.1325C61.3874 54.4617 61.5569 54.5263 61.6405 54.5534C61.7797 54.5984 62.012 54.619 62.2898 54.5349C62.5675 54.4508 62.7494 54.3048 62.8403 54.1901C62.8948 54.1212 63 53.9734 63 53.5778V20C63 16.134 66.134 13 70 13Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1402_1689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.5 3.45349e-06) rotate(106.962) scale(104.548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F27121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A2387"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87f403d3b57e1bf5ed0fef38ceb1a1d5.svg";
export { ForwardRef as ReactComponent };